// Modules
import 'rc-time-picker/assets/index.css';

import React from 'react';
import TimePicker from 'rc-time-picker';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';

import Popover from 'components/widgets/overlays/popover';
import Timer from 'services/data/timer';

import * as actions from './actions';

// Component
class Time extends React.Component {
  constructor() {
    super();

    this.configureInterval = this.configureInterval.bind(this);
    this.updateTime = this.updateTime.bind(this);
  }

  componentDidMount() {
    this.configureInterval();
  }

  componentDidUpdate() {
    this.configureInterval();
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
      delete this.interval;
    }
  }

  configureInterval() {
    const active = Timer.isActive(this.props.timer);

    if (active && !this.interval) this.interval = setInterval(() => this.forceUpdate(), 1000);

    if (!active && this.interval) {
      clearInterval(this.interval);
      delete this.interval;
    }
  }

  updateTime(interval, time, type) {
    actions.updateInterval(this.props.timer, { ...interval, [type]: time.toDate() });
  }

  render() {
    const { timer } = this.props;
    const duration = Timer.getDuration(timer);
    const archived = timer.status === 'Archived';
    const hours = _.padStart(duration.hours(), 2, 0);
    const minutes = _.padStart(duration.minutes(), 2, 0);
    const seconds = _.padStart(duration.seconds(), 2, 0);

    const trigger = (
      <span className={classNames('text-monospace pointer', { 'text-silver': archived })} style={{ fontSize: '1.75rem', fontWeight: 200 }}>
        {hours}:{minutes}:{seconds}
      </span>
    );

    return (
      <Popover
        id={`timer-manage-time-${timer.uuid}`}
        className="popover-no-padding"
        trigger={trigger}
        title="Manage Time"
        ref={(popover) => { this.popover = popover; }}
      >
        <div className="p-3">
          {_.map(timer.timerIntervals, interval =>
            <div className="d-flex align-items-center" key={interval.id}>
              <TimePicker
                showSecond={false}
                value={moment(interval.start)}
                className="flex-grow"
                style={{ flexBasis: 0 }}
                onChange={time => this.updateTime(interval, time, 'start')}
                format="h:mm a"
                use12Hours
                inputReadOnly
              />
              <span className="m-2">to</span>
              { !interval.end && <div className="flex-grow" style={{ flexBasis: 0 }}>Active</div>}
              { interval.end &&
                <TimePicker
                  showSecond={false}
                  value={moment(interval.end)}
                  className="flex-grow"
                  style={{ flexBasis: 0 }}
                  onChange={time => this.updateTime(interval, time, 'end')}
                  format="h:mm a"
                  use12Hours
                  inputReadOnly
                />
              }
            </div>
          )}
        </div>
      </Popover>
      
    );
  }
}

// Exports
export default Time;



// WEBPACK FOOTER //
// ./app/modules/timers/time.js